import React, { useState, useCallback, useEffect } from 'react';
import HeroCarousel from '@/components/ui/HeroCarousel';
import MovieCarousel from '@/components/ui/MovieCarousel';
import { useNavigate } from 'react-router-dom';
import { PageSkeleton } from '@/components/ui/LoadingSkeleton';
import { fetchTrending, fetchTopRated, fetchByGenre, fetchNowPlaying, GENRES } from '@/services/tmdb';

const HomePage = () => {
  const navigate = useNavigate();
  const [selectedMovie, setSelectedMovie] = useState(null);

  // State for data
  const [heroMovies, setHeroMovies] = useState([]);
  const [trendingMovies, setTrendingMovies] = useState([]);
  const [topRatedMovies, setTopRatedMovies] = useState([]);
  const [actionMovies, setActionMovies] = useState([]);
  const [comedyMovies, setComedyMovies] = useState([]);
  const [scifiMovies, setScifiMovies] = useState([]);
  const [horrorMovies, setHorrorMovies] = useState([]);
  const [nowPlayingMovies, setNowPlayingMovies] = useState([]);
  const [animatedMovies, setAnimatedMovies] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [
          trending,
          topRated,
          action,
          comedy,
          scifi,
          horror,
          nowPlaying,
          animated
        ] = await Promise.all([
          fetchTrending(),
          fetchTopRated(),
          fetchByGenre(GENRES.ACTION),
          fetchByGenre(GENRES.COMEDY),
          fetchByGenre(GENRES.SCIFI),
          fetchByGenre(GENRES.HORROR),
          fetchNowPlaying(),
          fetchByGenre(GENRES.ANIMATION),
        ]);

        setHeroMovies(trending.results.slice(0, 5)); // Top 5 for hero
        setTrendingMovies(trending.results);
        setTopRatedMovies(topRated.results);
        setActionMovies(action.results);
        setComedyMovies(comedy.results);
        setScifiMovies(scifi.results);
        setHorrorMovies(horror.results);
        setNowPlayingMovies(nowPlaying.results);
        setAnimatedMovies(animated.results);
      } catch (error) {
        console.error("Failed to load TMDb data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, []);

  // Handle showing movie details
  const handleShowDetails = useCallback((movie) => {
    navigate(`/movie/${movie.id}`);
  }, [navigate]);

  if (isLoading) {
    return <PageSkeleton />;
  }

  return (
    <main className="min-h-screen bg-background">
      {/* Hero Section */}
      <HeroCarousel
        movies={heroMovies}
        onShowDetails={handleShowDetails}
      />

      {/* Movie Categories */}
      <section className="relative z-30 mt-4 md:-mt-24 pb-12 md:pb-16 px-4 md:px-12 space-y-8">
        <MovieCarousel title="Agregadas Recientemente" movies={nowPlayingMovies} onShowDetails={handleShowDetails} />
        <MovieCarousel title="Animación" movies={animatedMovies} onShowDetails={handleShowDetails} />
        <MovieCarousel title="Tendencias" movies={trendingMovies} onShowDetails={handleShowDetails} />
        <MovieCarousel title="Mejor Valoradas" movies={topRatedMovies} onShowDetails={handleShowDetails} />
        <MovieCarousel title="Acción" movies={actionMovies} onShowDetails={handleShowDetails} />
        <MovieCarousel title="Comedia" movies={comedyMovies} onShowDetails={handleShowDetails} />
        <MovieCarousel title="Ciencia Ficción" movies={scifiMovies} onShowDetails={handleShowDetails} />
        <MovieCarousel title="Terror" movies={horrorMovies} onShowDetails={handleShowDetails} />
      </section>

      {/* Movie Detail Modal */}

    </main>
  );
};

export default HomePage;
